import { GuidedTourAudience } from '../models/guide/guided-tour.model';

export interface TourPromptContent {
  title: string;
  description: string;
  icon: string;
}

export function getTourPromptContent(audience: GuidedTourAudience): TourPromptContent {
  switch (audience) {
    case 'search':
      return {
        title: 'Take a quick tour?',
        description:
          'Learn how to search, filter, and compare healthcare providers on this page. You can always start the tour later from the button above.',
        icon: 'pi pi-compass',
      };
    case 'patient':
      return {
        title: 'New to your dashboard?',
        description:
          'A short walkthrough can show you where to find bookings, favorites, and upcoming visits. You can skip this and explore on your own.',
        icon: 'pi pi-compass',
      };
    case 'provider':
      return {
        title: 'Want a quick tour?',
        description:
          'See how to manage bookings, services, schedule, and payouts from your provider dashboard. You can open the tour anytime from the guide button.',
        icon: 'pi pi-compass',
      };
  }
}
